var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select as ChakraSelect } from '@chakra-ui/react';
export const Select = (_a) => {
    var { options, value, isError = false } = _a, props = __rest(_a, ["options", "value", "isError"]);
    return (_jsx(ChakraSelect, Object.assign({ value: value, variant: "flushed" }, props, { isInvalid: isError, color: isError ? 'error' : 'text' }, { children: options.map(({ value, label }) => (_jsx("option", Object.assign({ value: value }, { children: label }), value))) })));
};
//# sourceMappingURL=Select.js.map